<script>
    import user from "../stores/user";
    import A from "../lib/Router/A.svelte";
    import Warning from "../components/pages/Warning.svelte";
    import OrderData from "./OrderData.svelte";

    export let hash;
</script>

<div class="container">
    {#if $user.token}
        <div class="mb-5">
            <h1>Η αγορά ολοκληρώθηκε</h1>
            <div class="heading-separator"></div>
        </div>
        <p>Η αγορά σας ολοκληρώθηκε επιτυχώς.</p>
        <p class="mb-6">
            Θα λάβετε ένα email στην ηλεκτρονική σας διεύθυνση με τα στοιχεία της παραγγελίας σας.
        </p>
<!--        <h2 class="mb-5">Στοιχεία παραγγελίας</h2>-->
        <OrderData {hash} page="order-completed"/>
        <div class="text-center">
            <A href="/" class="btn btn-link"><b>Επιστροφή στην αρχική</b></A>
        </div>
    {:else}
        <Warning warning="no-user" page="order-details" header="Σύνδεση στον λογαριασμό σας"/>
    {/if}
</div>